import { useApiBase } from 'api/base';
import { useCallback } from 'react';

export class IdentidadeAutenticarTelefoneProps {
    public constructor(
        public telefone: string = '',
        public senha: string = '',
        public filtros?: {
            contratoId?: string
        }
    ) { }
}

export function usePostIdentidadeAutenticarTelefone() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const postIdentidadeAutenticarTelefone = useCallback(
        (autenticacaoProps: IdentidadeAutenticarTelefoneProps) =>
        invocarApi({
            method: 'POST',
            url: `/v4/Auth/token-telefone`,
            data: autenticacaoProps,
            enviarTokenUsuario: false,
        }),
        [invocarApi],
    );
    return {
        ...outrasPropriedades,
        postIdentidadeAutenticarTelefone,
    };
}
